@use "../../../../../scss/settings/colors";
@use "../../../../../scss/settings/breakpoints";

.table_container {
  box-shadow: none;
  border-radius: 8px;
  background-color: colors.$base-white !important;
}

.empty_message {
  max-width: 228px;
  margin-left: auto;
  margin-right: auto;
  font-family: "Light Inter", sans-serif;
  font-style: italic;
  font-size: 0.875rem;
  line-height: 1.3125rem;
  text-align: center;
  color: colors.$dark-blue;
}

.profile_container,
.file_type_container,
.date_container {
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    fill: colors.$dark-blue;;
  }

}

.profile_icon,
.file_type_icon {
  display: flex;
  align-items: center;
  color: colors.$dark-blue;

  svg {
    fill: colors.$dark-blue;
  }

  .MuiSvgIcon-root {
    width: 24px !important;
    height: 24px !important;
  }

}

.profile_icon {
  width: 24px;
  height: 24px;
  justify-content: center;
}


.actions_container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding-left: 8px;

  .action_button {
    flex-shrink: 0;

    svg {
      fill: colors.$dark-blue !important;
    }


    &:hover {

      svg {
        fill: colors.$dark-blue !important;
      }

    }

  }

}

.header_cell {
  &.actions_header {
    text-align: right;
    padding-left: 24px;
  }
}

.badge_new {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 45px;
  height: 20px;
  font-family: "Medium Inter", sans-serif;
  font-size: 12px;
  color: colors.$text-black-4;
  background-color: colors.$blue-variant-2;
  border-radius: 4px;
}

.table_row {
  border-bottom: 1px solid colors.$gray-variant-4;
  transition: border-color 0.3s;
  cursor: pointer;

  &.doc_new {

    td {
      //border-color: colors.$brand-purple;

      &:first-child {
        //border-left: 1px solid colors.$brand-purple;
      }

      &:last-child {
        //border-right: 1px solid colors.$brand-purple;
      }

    }

    &:first-child {

      td {
        //border-top: 1px solid colors.$brand-purple;
        //border-bottom: 1px solid colors.$brand-purple;
      }

    }

  }

}

.table_cell {
  padding: 16px;

  .cell_text {
    color: colors.$dark-blue;
  }

}

.profile_text {
  min-width: 100px;
  max-width: 150px;
  color: colors.$dark-blue;
}

.file_name_container {
  width: 295px;
  color: colors.$dark-blue;
}

.header_text {
  color: colors.$dark-blue;
}

.file_type_chip {
  border-radius: 16px;
  padding: 2px 8px;
  display: inline-block;
  font-size: 12px;
  font-weight: 500;
}

.date_container {
  display: flex;
  align-items: center;
  gap: 4px;

  .cell_text {
    white-space: nowrap;
  }

}

.green_label, .blue_label {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 2px 4px;
  font-family: 'Medium Inter', sans-serif;
  font-size: 12px;
  color: colors.$text-black;
  background-color: colors.$green-variant-light;
  border-radius: 4px;
}

.blue_label {
  background-color: colors.$blue-variant-2;
}

// ---------- Compact rows (Document Vault page) ----------
// Two classes, so the 16px radius outranks the MUI Paper default radius.
.table_container.table_container_compact {
  border: 1px solid colors.$gray-variant-4;
  border-radius: 16px;

  // Inside the Document Vault block the block itself draws the border and the rounded corners.
  &.table_container_embedded {
    // 100vh minus the app header, the page description and the block header (which now holds
    // the pagination as well).
    max-height: calc(100vh - 133px);
    border: none;
    border-radius: 0;

    @media #{breakpoints.$tablet-mobile}{
      max-height: none;
    }
  }
}

.compact_table {
  border-collapse: separate;
}

.compact_row {
  border-bottom: none;
  transition: background-color 0.2s;

  :global(.MuiTableCell-root) {
    border-bottom: 1px solid colors.$gray-variant-4;
  }

  &:last-child :global(.MuiTableCell-root) {
    border-bottom: none;
  }

  &:hover {
    background-color: colors.$gray-variant-20;
  }

  .table_cell {
    padding: 12px 16px;
    vertical-align: middle;
  }
}

// The name column takes all the free width; the dates and actions columns shrink to fit.
.compact_name_cell {
  width: 100%;
  min-width: 260px;
}

.compact_dates_cell,
.compact_actions_cell {
  width: 1%;
  white-space: nowrap;
}

.compact_name_container {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

// File type badge at the start of the row.
.file_badge {
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  font-family: 'Bold Inter', sans-serif;
  font-size: 10px;
  line-height: 1;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: colors.$dark-blue;
  background-color: colors.$gray-variant-20;
  border-radius: 10px;

  &.file_badge_pdf {
    color: #b42318;
    background-color: #fdecec;
  }

  &.file_badge_word {
    color: #1849a9;
    background-color: #e6efff;
  }

  &.file_badge_image {
    color: #067647;
    background-color: #e3f6ea;
  }

  &.file_badge_bk {
    color: colors.$brand-purple;
    background-color: colors.$light-purple;
  }
}

.compact_text_container {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.compact_title_line {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 0;
}

.compact_title:global(.MuiTypography-root) {
  font-family: 'Bold Inter', sans-serif !important;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: colors.$dark-blue;
  overflow-wrap: anywhere;
}

.compact_status {
  flex-shrink: 0;
  padding: 1px 8px;
  font-size: 11px;
  border-radius: 999px;
}

.compact_subtitle:global(.MuiTypography-root) {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-family: 'Regular Inter', sans-serif;
  font-size: 0.75rem;
  line-height: 1.125rem;
  color: colors.$gray-variant-16;
}

.compact_profile {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.compact_profile_icon {
  display: inline-flex;
  font-size: 14px;
}

.compact_separator {
  margin: 0 8px;
}

.compact_dates {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.compact_date:global(.MuiTypography-root) {
  font-family: 'Medium Inter', sans-serif;
  font-size: 0.75rem;
  line-height: 1.125rem;
  color: colors.$dark-blue;
}

.compact_date_end:global(.MuiTypography-root) {
  font-family: 'SemiBold Inter', sans-serif;
  color: colors.$brand-purple;
}

// "Updated" / "Ends / renews" words before the dates.
.compact_date_label {
  font-family: 'Bold Inter', sans-serif;
  font-weight: 700;
}

// ---------- Responsive ----------
.file_name_container {

  @media #{breakpoints.$mobile}{
    width: auto;
    min-width: 180px;
  }

}

.table_cell {

  @media #{breakpoints.$mobile}{
    padding: 12px 8px;
  }

}

.compact_row .table_cell {

  @media #{breakpoints.$mobile}{
    padding: 12px;
  }

}

.compact_name_cell {

  @media #{breakpoints.$mobile}{
    min-width: 220px;
  }

}
